import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['source', 'destination']

  connect() {
    this.toggle();
  }

  toggle() {
    let selected_option;
    if (this.sourceTargets.length > 1) {
      selected_option = this.sourceTargets.filter((entry) => { return entry.checked })[0];
    } else {
      selected_option = this.sourceTarget.options[this.sourceTarget.selectedIndex];
    }
    let enabled_element_class = selected_option.dataset.toggledElementClass;

    this.destinationTargets.forEach(element => {
      if (element.className.indexOf(enabled_element_class) == -1) {
        this.toggleElement(element, 'off');
      } else {
        this.toggleElement(element, 'on');
      }
    })
  }

  toggleElement(element, state) {
    let displayStatus = state == 'on' ? 'block' : 'none';
    let disabled = (state == 'off');

    element.style.display = displayStatus;
    if (element.nodeName == 'FIELDSET') {
      element.disabled = disabled
    } else {
      let input = element.querySelectorAll('select, input');
      input.forEach(e => e.disabled = disabled)
    }
  }
}